import styled, { DefaultTheme } from "styled-components";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

const TOGGLE_BAR_WIDTH = 40;
const TOGGLE_BAR_HEIGHT = 24;
const TOGGLE_THUMB_WIDTH = 16;
const TOGGLE_THUMB_HEIGHT = 16;
const TOGGLE_THUMB_TOP_POSITION = (TOGGLE_BAR_HEIGHT - TOGGLE_THUMB_HEIGHT) / 2;
const TOGGLE_THUMB_LEFT_POSITION = TOGGLE_THUMB_TOP_POSITION;

function getToggleBgColor(
    theme: DefaultTheme,
    $isActive: boolean,
    $activeColor?: keyof IColors,
    $backgroundColor?: keyof IColors,
) {
    if ($isActive) {
        return $activeColor
            ? theme.colors[theme.colorMode][$activeColor]
            : theme.colors[theme.colorMode].special_positive;
    }
    return $backgroundColor
        ? theme.colors[theme.colorMode][$backgroundColor]
        : theme.colors[theme.colorMode].background_Secondary;
}

export const ToggleBarStyled = styled.span<{
    $isActive: boolean;
    $isDisabled: boolean;
    $activeColor?: keyof IColors;
    $backgroundColor?: keyof IColors;
}>(({ theme, $isActive, $isDisabled, $activeColor, $backgroundColor }) => ({
    background: getToggleBgColor(theme, $isActive, $activeColor, $backgroundColor),
    width: `${TOGGLE_BAR_WIDTH}px`,
    height: `${TOGGLE_BAR_HEIGHT}px`,
    position: "relative",
    transition: "background 0.15s linear",
    willChange: "background",
    backfaceVisibility: "hidden",
    transform: "translateZ(0)",
    contain: "layout",
    display: "inline-block",
    boxShadow: "inset 0px 1px 2px rgba(0, 0, 0, 0.08)",
    borderRadius: theme.cornerRadius.medium,
    opacity: $isDisabled ? 0.5 : 1,
}));

export const ToggleThumbStyled = styled.span<{
    $isActive: boolean;
    $thumbColor?: keyof IColors;
}>(({ theme, $isActive, $thumbColor }) => ({
    position: "absolute",
    top: `${TOGGLE_THUMB_TOP_POSITION}px`,
    left: `${TOGGLE_THUMB_LEFT_POSITION}px`,
    width: `${TOGGLE_THUMB_WIDTH}px`,
    height: `${TOGGLE_THUMB_HEIGHT}px`,
    background: $thumbColor
        ? theme.colors[theme.colorMode][$thumbColor]
        : theme.colors[theme.colorMode].background_Primary,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.12)",
    transition: "all 0.15s linear",
    backfaceVisibility: "hidden",
    willChange: "transform, border-color",
    contain: "strict",
    borderRadius: `${TOGGLE_THUMB_HEIGHT / 2}px`,
    border: "none",
    transform: $isActive ? `translate3d(${TOGGLE_THUMB_WIDTH}px, 0, 0)` : "translate3d(0, 0, 0)",
}));
